export default __webpack_public_path__ + "static/media/agentes-da-alegria-1.4b32aa74.jpg";